import { useState, useEffect, useCallback } from 'react';
import { message } from 'antd';

export const usePharmacyData = (pharmacyId, apiClasses) => {
  const [pharmacy, setPharmacy] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPharmacyData = useCallback(async () => {
    if (!apiClasses?.PrescriptionsAPI || !pharmacyId) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await apiClasses.PrescriptionsAPI.getPharmacybyId(pharmacyId);
      setPharmacy(response.data?.pharmacy || null);
    } catch (err) {
      setError(err.message || 'Failed to fetch pharmacy data');
      message.error('Error fetching pharmacy information');
    } finally {
      setLoading(false);
    }
  }, [pharmacyId, apiClasses?.PrescriptionsAPI]);

  useEffect(() => {
    fetchPharmacyData();
  }, [fetchPharmacyData]);

  return {
    pharmacy,
    loading,
    error,
    refetch: fetchPharmacyData
  };
};
